export default {
  SIGN_IN(state, data) {
    state.apiToken = data.apiToken;
    state.appUser = JSON.parse(data.appUser);
  },
  SIGN_OUT(state) {
    setTimeout(() => {
      state.appUser = null;
      state.buttonLoading = false;
    }, 100);
    state.apiToken = null;
    localStorage.removeItem('appUser');
    localStorage.removeItem('apiToken');
    sessionStorage.removeItem('apiToken');
    sessionStorage.removeItem('appUser');
  },
  SET_SNACKBAR(state, payload) {
    state.snackbar.show = true;
    state.snackbar.message = payload;
  },
  SET_APP_LOADING(state, payload) {
    state.appLoading = payload;
  },
  SET_STATES(state, payload) {
    state.states = payload;
  },
  SET_CITIES(state, payload) {
    if (state.cities.find(item => item.state === payload.state)) {
      state.cities.find(item => item.state === payload.state).data.push(...payload.cities);
    } else {
      state.cities.push({
        state: payload.state,
        data: payload.cities,
      });
    }
  },
};
